import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=b90d5b16&"
import script from "./Get.vue?vue&type=script&lang=js&"
export * from "./Get.vue?vue&type=script&lang=js&"
import style0 from "./Get.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports